// define api endpoint here
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

export const API_LOGIN = '/cms/login'
export const API_GET_MAGAZINE_APPS = '/cms/apps'
// user
export const API_GET_USERS = '/cms/users'
export const API_USERS_DETAIL = '/cms/users/:id'
// notification
export const API_GET_NOTIFICATION = '/cms/notifications'
export const API_DETAIL_NOTIFICATION = '/cms/notifications/:id'
export const API_GET_CERIFICATE = '/cms/certificate-exp'
export const API_POST_CERTIFICATE_UPLOAD= '/cms/certificate/upload'
//magazine
export const API_GET_MAGAZINE = '/cms/magazines'
export const API_CREATE_MAGAZINE_CMS = '/cms/magazines'
export const API_MAGAZINE_DETAIL_CMS = '/cms/magazines/:id'
export const API_UPDATE_MULTIPLE_MAGAZINE = '/cms/magazines/multi-saving'
// uploads (BE proxies AWS credentials via presigned URLs)
export const API_UPLOAD_PRESIGN = '/cms/uploads/presign'
export const API_UPLOAD_COMPLETE_MULTIPART = '/cms/uploads/complete-multipart'
export const API_UPLOAD_ABORT_MULTIPART = '/cms/uploads/abort-multipart'
// app-setting
export const API_GET_SETTING_APP = '/cms/app-setting'
export const API_SAVE_JWT_INFORM ='/cms/upload-jwt-private-key'
export const API_GET_JWT_INFORM ='/cms/get-jwt-private-key'
export const API_GET_PRODUCTS_IN_STORE = '/jwtEncode'

// category
export const API_GET_CATEGORY = '/categories'
export const API_CATEGORY_DETAIL = '/cms/categories/:id'

// device
export const API_GET_DEVICE_NOTIFICATION = '/cms/number-of-devices'
// banner
export const API_GET_BANNER = '/banners'
export const API_CREATE_BANNER = '/cms/banners'
export const API_BANNER_DETAIL = '/cms/banners/:id'

// subcriber id
export const API_IMPORT_DIGITAL_USER = '/cms/digital/import'
export const API_EXPORT_DIGITAL_USER = '/cms/digital/export'

//subcription
export const API_GET_SUBSCRIPTION = '/subscriptions'
export const API_POST_SUBSCRIPTION = '/cms/subscriptions'
//
export const API_GET_IMAGE_FROM_BASE64 = '/clients/magazine/pages'
export const API_APPY_CSV_SPECIAL = '/cms/new-csv'
export const API_STATUS_CSV_SPECIAL = '/cms/president-latest-status'
